export default __webpack_public_path__ + "static/media/ExtendStay.38fbdff3.graphql";